import { Antwoord, ValidatieParameter } from '@models/claims';
import { VraagboomTextResultaat } from '@models/vragenboom';
import { ValidatieregelHelper } from './validatieregel-helper';

// @dynamic
export class KentekenValidator {
  static isValidKenteken(antwoord: Antwoord, value: string) {
    if (antwoord == null) {
      return false;
    }

    if (value) {
      const kentekenValidator: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'KENTEKEN');
      if (kentekenValidator != null) {
        let geldigKenteken = KentekenValidator.isGeldigKenteken(value);
        if (geldigKenteken.kentekenValid) {
          value = geldigKenteken.kentekenOpgemaakt;
        } else {
          return false;
        }
      }
    }

    return true;
  }

  static isGeldigKenteken(kenteken: string) {
    let kentekenValid = false;
    let kentekenOpgemaakt = kenteken;
    kenteken = kenteken.toUpperCase().replace(/-/g, '');
    const arrRegEx = ['^([A-Z]{2})([0-9]{2})([0-9]{2})$', // XX9999
      '^([0-9]{2})([0-9]{2})([A-Z]{2})$', // 9999XX
      '^([0-9]{2})([A-Z]{2})([0-9]{2})$', // 99XX99
      '^([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{2})$', // XX99XX
      '^([BDFGHJKLMNPRSTVWXYZ]{2})([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{2})$', // XXXX99
      '^([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{2})([BDFGHJKLMNPRSTVWXYZ]{2})$', // 99XXXX
      '^([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{3})([0-9]{1})$', // 99XXX9
      '^([0-9]{1})([BDFGHJKLMNPRSTVWXYZ]{3})([0-9]{2})$', // 9XXX99
      '^([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{3})([BDFGHJKLMNPRSTVWXYZ]{1})$', // XX999X
      '^([BDFGHJKLMNPRSTVWXYZ]{1})([0-9]{3})([BDFGHJKLMNPRSTVWXYZ]{2})$', // X999XX
      '^((?!PVV|VVD|SGP)[BDFGHJKLMNPRSTVWXYZ]{3})([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{1})$', // XXX99X
      '^([BDFGHJKLMNPRSTVWXYZ]{1})([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{3})$', // X99XXX
      '^([0-9]{1})([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{3})$', // 9XX999
      '^([0-9]{3})([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{1})$' // 999XX9
    ];

    if (kenteken.length === 6) {
      let index = 0;
      arrRegEx.some((regEx, i) => {
        const re = new RegExp(regEx);
        const res = re.test(kenteken);
        // match on regex pattern
        if (res === true) {
          index = i;
          kentekenValid = true;
          return true;
        }
      });

      if (kentekenValid) {
        const re = new RegExp(arrRegEx[index]);
        kentekenOpgemaakt = kenteken.replace(re, '$1-$2-$3');
      }
    }

    return { kentekenValid, kentekenOpgemaakt };
  }
}
